var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurrencyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  color: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#currency-Icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#8593A3",
  d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.375 7.5h5.25m-5.25-2.625h5.25M10.5 13.5l-4.125-3.375H7.5c3.334 0 3.334-5.25 0-5.25M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "currency-Icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})))));
export { SvgCurrencyIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/currency-Icon.56a9c77753dada33f0a07ea985571fb2.svg";